var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_635_17236)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.7449 8.80861C6.60758 8.49964 6.53087 8.15575 6.53087 8.00101C6.53087 6.65975 7.58039 5.57227 8.87484 5.57227C10.1692 5.57227 11.2188 6.65975 11.2188 8.00101C11.2188 9.34221 10.0468 10.2222 8.87484 10.2222C8.12517 10.2222 7.45791 9.85809 7.0299 9.29124C6.91773 9.14301 6.82156 8.98112 6.7449 8.80861ZM8.87484 9.00781C8.58185 9.00781 8.314 8.89632 8.10802 8.71192C7.85963 8.48958 7.75028 8.16049 7.75028 8.00101C7.75028 7.33038 8.22704 6.78661 8.87484 6.78661C9.52259 6.78661 10.0524 7.32947 10.0524 8.00009C10.0524 8.46318 9.52259 9.00781 8.87484 9.00781Z",
    fill: "#1C1919"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3308 8.15562C16.3399 8.14437 16.3216 8.16745 16.3308 8.15562C16.4024 8.05831 16.4006 7.94259 16.3304 7.84414C16.3253 7.83694 16.3201 7.82945 16.3148 7.82179C14.2077 4.7675 11.5949 3.14282 8.89386 3.14282C6.19566 3.14282 3.5851 4.76313 1.48037 7.81128C1.44043 7.86911 1.42028 7.92854 1.42028 7.99968C1.42028 8.07431 1.44371 8.13705 1.48572 8.19774C3.58988 11.2401 6.19813 12.8571 8.89386 12.8571C11.6017 12.8571 14.2215 11.2247 16.3308 8.15562ZM14.6923 7.62997C14.8655 7.84379 14.8655 8.15551 14.6923 8.36939C12.888 10.5967 10.8564 11.6428 8.89386 11.6428C6.93128 11.6428 4.8997 10.5967 3.09539 8.36939C2.92216 8.15551 2.92216 7.84379 3.09539 7.62997C4.8997 5.40268 6.93128 4.35718 8.89386 4.35718C10.8564 4.35718 12.888 5.40268 14.6923 7.62997Z",
    fill: "#1C1919"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_635_17236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.1145,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 16.959 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.db1f9d0febcae0fecfca8a022087776c.svg";
export { ForwardRef as ReactComponent };